<template>
  <div style="display: flex; align-items: center;">
    <img :src="flagImageSrc" style="margin-right: 5px; width: 24px; height: 24px;" />
    <small v-if="withCountryName">{{ countryName }}</small>
  </div>
</template>

<script>
import countries from "@/data/countries";

export default {
  props: {
    countryCode: {
      type: String,
      required: true
    },

    withCountryName: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    countryName() {
      return countries[this.countryCode.toUpperCase()];
    },

    flagImageSrc() {
      return `https://flagpedia.net/data/flags/h80/${this.countryCode.toLowerCase()}.webp`;
    }
  }
};
</script>
